import request from '../utils/request'

// 获取报价
export function getQuote(data) {
  return request({
    url: '/quote',
    method: 'post',
    data
  })
}

// 获取运车案例
export function getCases(params) {
  return request({
    url: '/cases',
    method: 'get',
    params
  })
}

// 获取新闻资讯
export function getNews(params) {
  return request({
    url: '/news',
    method: 'get',
    params
  })
}

// 获取新闻详情
export function getNewsDetail(id) {
  return request({
    url: `/news/${id}`,
    method: 'get'
  })
}

// 提交订单
export function submitOrder(data) {
  return request({
    url: '/order',
    method: 'post',
    data
  })
}

// 获取轮播图
export function getBanners() {
  return request({
    url: '/banner',
    method: 'get'
  })
}

// 获取联系方式
export function getContact() {
  return request({
    url: '/contact',
    method: 'get'
  })
}

// 获取客服配置
export function getServiceConfig() {
  return request({
    url: '/service',
    method: 'get'
  })
}

// 获取合作伙伴
export function getPartners() {
  return request({
    url: '/partners',
    method: 'get'
  })
}

// 获取关于我们
export function getAbout() {
  return request({
    url: '/about',
    method: 'get'
  })
}

// 员工H5订单系统登录
export function staffOrderLogin(data) {
  return request({
    url: '/staff/orders/login',
    method: 'post',
    data
  })
}

// 员工H5订单查询
export function getStaffOrders(params, token) {
  return request({
    url: '/staff/orders',
    method: 'get',
    params,
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
}

// 员工H5订单详情
export function getStaffOrderDetail(id, token) {
  return request({
    url: `/staff/orders/${id}`,
    method: 'get',
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
}

// 员工H5修改订单状态
export function updateStaffOrderStatus(id, data, token) {
  return request({
    url: `/staff/orders/${id}/status`,
    method: 'put',
    data,
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
}
